module.exports = __webpack_public_path__ + "static/media/sort-amount-down.c6f1f900.svg";